window.bundleDataW = {
"Walker-boy": {
displayName: "Walker",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Walker Personalized Coloring Experience",
variantId: "49412035346669",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/WALKER_FINAL_COVER.png?v=1772032668",
price: "$14.99",
preorder: true
},
{
title: "Walker Dragon Holographic Sticker",
variantId: "49933760626925",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Walker_holographic_sticker.png?v=1780106104",
price: "$4.99",
preorder: false
},
{
title: "Walker Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Wes-boy": {
displayName: "Wes",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Wes Personalized Coloring Experience",
variantId: "49655158407405",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Wes_final_cover.png?v=1773501514",
price: "$14.99",
preorder: true
},
{
title: "Wes Dragon Holographic Sticker",
variantId: "49933754695917",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Wes_holographic_sticker.png?v=1780106110",
price: "$4.99",
preorder: false
},
{
title: "Wes Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Wesley-boy": {
displayName: "Wesley",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Wesley Personalized Coloring Experience",
variantId: "49414807585005",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Wesley.png?v=1772144908",
price: "$14.99",
preorder: true
},
{
title: "Wesley Dragon Holographic Sticker",
variantId: "49933760200941",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Wesley_holographic_sticker.png?v=1780106104",
price: "$4.99",
preorder: false
},
{
title: "Wesley Calling Gift Sticker",
variantId: "49933465977069",
image: "https://lkbunting.com/cdn/shop/files/4838A05A-04A0-4B87-B29E-D1DD51D0D666.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Weston-boy": {
displayName: "Weston",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Weston Personalized Coloring Experience",
variantId: "49414808699117",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Weston.png?v=1772144861",
price: "$14.99",
preorder: true
},
{
title: "Weston Dragon Holographic Sticker",
variantId: "49933760168173",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Weston_holographic_sticker.png?v=1780106109",
price: "$4.99",
preorder: false
},
{
title: "Weston Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"William-boy": {
displayName: "William",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "William Personalized Coloring Experience",
variantId: "49279574638829",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/William_final_cover.png?v=1772753296",
price: "$14.99",
preorder: true
},
{
title: "William Dragon Holographic Sticker",
variantId: "49933773013229",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/William_holographic_sticker.png?v=1780106110",
price: "$4.99",
preorder: false
},
{
title: "William Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Willow-girl": {
displayName: "Willow",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Willow Personalized Coloring Experience",
variantId: "49666660139245",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Willow_final_cover.png?v=1773592233",
price: "$14.99",
preorder: true
},
{
title: "Willow Unicorn Holographic Sticker",
variantId: "49933754106093",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Willow_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Willow Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Wyatt-boy": {
displayName: "Wyatt",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Wyatt Personalized Coloring Experience",
variantId: "49414809059565",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Wyatt.png?v=1772144711",
price: "$14.99",
preorder: true
},
{
title: "Wyatt Dragon Holographic Sticker",
variantId: "49933760135405",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Wyatt_holographic_sticker.png?v=1780106110",
price: "$4.99",
preorder: false
},
{
title: "Wyatt Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Waylon-boy": {
displayName: "Waylon",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Waylon Personalized Coloring Experience",
variantId: "50125991674093",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Waylon_final_cover.png?v=1781929666",
price: "$14.99",
preorder: true
},
{
title: "Waylon Dragon Holographic Sticker",
variantId: "50127075606765",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Waylonstickerwebsite.png?v=1781967849",
price: "$4.99",
preorder: false
},
{
title: "Waylon Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Walter-boy": {
displayName: "Walter",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Walter Personalized Coloring Experience",
variantId: "50457721045229",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Walter_final_cover.png?v=1786406748",
price: "$14.99",
preorder: true
},
{
title: "Walter Dragon Holographic Sticker",
variantId: "50457592955117",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Walter_holographic_sticker.png?v=1786406786",
price: "$4.99",
preorder: false
},
{
title: "Walter Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
},
"Wren-girl": {
displayName: "Wren",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Wren Personalized Coloring Experience",
variantId: "50643939131629",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Wren_final_cover_1873d7df-1df7-46b5-8680-0a6c720b1491.png?v=1788490621",
price: "$14.99",
preorder: true
},
{
title: "Wren Unicorn Holographic Sticker",
variantId: "50643951354093",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Wren_holographic_sticker.png?v=1788490590",
price: "$4.99",
preorder: false
},
{
title: "Wren Calling Gift Sticker",
variantId: "49933476167917",
image: "https://lkbunting.com/cdn/shop/files/A7B9C9D3-6947-4D40-92ED-A4BB6DA62635.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} 





};